export const coach = {
  "coach.custom-playlists.title": "Custom Playlists",
  "coach.custom-playlists.description": "Train on custom playlists made for you",
  "coach.scenario-editor.title": "Scenario Editor",
  "coach.scenario-editor.description": "Create and edit custom scenarios",
  "coach.bybcat.description": "Measure performance with a customised test",
  "coach.club-feature": "Club feature",
};
